var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"w-select-option t-size-m file-list-menu-click-detect",class:{
    't-is-disabled': _vm.disabled,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }